export function removeCovidFromKey(key) {
  return key.replace('covid-', '');
}

export function getLgIconForKey(key) {
  return `${removeCovidFromKey(key)}-lg`;
}
